/**
 * The Switchboard SPA shell (front-door-impl §11.1 / §11.5).
 *
 * The Switchboard is the house door — it belongs to no Angel — so it wears
 * BRASS chrome (docs/design-system.md "The Study"): the root sets
 * `--agent-accent: var(--brass)`, so the shared @charlie/design primitives
 * (Button "accent", focus rings, the Ember) render in house metal, never an
 * agent's accent.
 *
 * Routes:
 *   /login    — brass-chromed OTP + passkey login
 *   /account  — passkeys (register/manage)
 *   /         — the directory, "Your Angels" (one row in v1)
 *   /offline  — the brass fallback lock screen (also served statically as
 *               /offline.html by the backend; this is the in-SPA twin)
 */
import { Routes, Route, Navigate } from "react-router-dom";
import LoginPage from "./pages/LoginPage";
import AccountPage from "./pages/AccountPage";
import DirectoryPage from "./pages/DirectoryPage";
import OfflinePage from "./pages/OfflinePage";

export default function App() {
  return (
    // House brass: the Switchboard's accent IS the brass, everywhere.
    <div className="min-h-full" style={{ ["--agent-accent" as string]: "var(--brass)" }}>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/account" element={<AccountPage />} />
        <Route path="/offline" element={<OfflinePage />} />
        <Route path="/" element={<DirectoryPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </div>
  );
}
